import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import TasksService from 'mt-react-common/modules/tasks/services/TasksService/TasksService';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import * as formatter from 'mt-react-common/utils/formatter';
import { getDateDifferenceInDays } from 'mt-react-common/utils/otherHelpers';
import { t } from 'utils/translates';
import DefaultSelect from '../../../Common/Inputs/DefaultSelect';

// eslint-disable-next-line react/prefer-stateless-function
class TasksFastenForm extends Component {
  constructor(props) {
    super(props);
    const mainLabel = `${t('Главная')} + ${this.props.taskModel.taskTypeDesc}`;
    const categoryLabel = `${this.props.taskModel.taskTypeDesc}`;
    this.state = {
      days: '',
      errors: null,
      mainLabel,
      categoryLabel,
      queue:
        this.props.taskModel.autoLiftQueue !== null &&
        this.props.taskModel.autoLiftInterval
          ? this.props.taskModel.autoLiftQueue
          : 1000,
      autoUpTime: this.props.taskModel.autoLiftInterval || '10',
      categoriesSelect: {
        value: false,
        items: [
          {
            value: false,
            label: `${mainLabel} (${formatter.numberFormat(
              this.props.tasksUpListType.day_cost
            )}₽ / ${t('{days}д.', { days: 1 })})`,
            cost: this.props.tasksUpListType.day_cost
          },
          {
            value: true,
            label: `${categoryLabel} (${formatter.numberFormat(
              this.props.tasksUpListType.day_cost_by_category
            )}₽ / ${t('{days}д.', { days: 1 })})`,
            cost: this.props.tasksUpListType.day_cost_by_category
          }
        ]
      },
      showAutoLiftTaskBlock: !!(
        this.props.taskModel.autoLiftQueue &&
        this.props.taskModel.autoLiftInterval
      )
    };
    if (this.state.showAutoLiftTaskBlock) {
      // eslint-disable-next-line
      $(`#pinAutoLiftForm`).collapse('show');
    }
  }

  componentDidMount() {
    if (this.state.showAutoLiftTaskBlock) {
      // eslint-disable-next-line
      $(`#pinAutoLiftForm`).collapse('show');
    }
  }

  componentDidUpdate() {
    if (this.state.showAutoLiftTaskBlock) {
      // eslint-disable-next-line
      $(`#pinAutoLiftForm`).collapse('show');
    }
  }

  setAutoLiftInterval = (interval, queue) => {
    this.props.setLoading(true);
    TasksService.setAutoLiftInterval(
      this.props.taskModel.id,
      interval,
      queue
    ).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.updateTask();
          this.props.addClientNotice({
            type: 'success',
            message: result.data.message
          });
        } else if (result.status === 422) {
          this.setState({ errors: _.groupBy(result.data, 'field') });
        } else if ([423, 403].includes(result.status)) {
          this.props.addClientNotice({
            type: 'danger',
            message: result.data.message
          });
        }
      }
      this.props.setLoading(false);
    });
  };

  sendForm = () => {
    this.props.setLoading(true);
    TasksService.fastenTask(
      this.props.taskModel.id,
      this.state.days,
      this.state.categoriesSelect.value
    ).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.updateTask();
          this.props.updateAccountInfo();
          this.setState({ days: '', errors: null });
          this.props.addClientNotice({
            type: 'success',
            message: result.data.message
          });
        } else if (result.status === 422) {
          this.setState({ errors: _.groupBy(result.data, 'field') });
        } else if ([400, 423, 403].includes(result.status)) {
          this.props.addClientNotice({
            type: 'danger',
            message: result.data.message
          });
        }
      }
      this.props.setLoading(false);
    });
  };

  liftTask = () => {
    this.props.setLoading(true);
    TasksService.liftTask(this.props.taskModel.id).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.updateTask();
          this.props.updateAccountInfo();
          this.props.addClientNotice({
            type: 'success',
            message: result.data.message
          });
        } else if ([400, 423, 403].includes(result.status)) {
          this.props.addClientNotice({
            type: 'danger',
            message: result.data.message
          });
        }
      }
      this.props.setLoading(false);
    });
  };

  render() {
    const hasError = field => this.state.errors && this.state.errors[field];
    const errorDesc = field => {
      if (hasError(field)) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {this.state.errors[field][0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    const activeCategoriesSelect = this.state.categoriesSelect.items.find(
      item => item.value === this.state.categoriesSelect.value
    );
    const costLiftTask = 5;
    const getTotalCost = () => {
      if (
        this.state.days &&
        activeCategoriesSelect.value === false &&
        (this.props.taskModel.upListFastenNow ||
          this.props.taskModel.upListFastenByCategoryNow)
      ) {
        const andTimeUpListFastenNow = this.props.taskModel.upListFastenNow
          ? new Date(this.props.taskModel.upListFastenNow.andTime)
          : new Date();
        // console.log('andTimeUpListFastenNow', andTimeUpListFastenNow);
        const andTimeUpListFastenByCategoryNow = this.props.taskModel
          .upListFastenByCategoryNow
          ? new Date(this.props.taskModel.upListFastenByCategoryNow.andTime)
          : new Date();
        /* console.log(
          'andTimeUpListFastenByCategoryNow',
          andTimeUpListFastenByCategoryNow
        ); */
        if (andTimeUpListFastenByCategoryNow > andTimeUpListFastenNow) {
          const diffDays = getDateDifferenceInDays(
            andTimeUpListFastenNow,
            andTimeUpListFastenByCategoryNow
          );
          // console.log(diffDays);
          if (this.state.days > diffDays) {
            return (
              activeCategoriesSelect.cost * this.state.days -
              this.props.tasksUpListType.day_cost_by_category * diffDays
            );
          }
          return (
            this.props.tasksUpListType.day_cost_by_category * this.state.days
          );
        }
      }
      return activeCategoriesSelect.cost * this.state.days;
    };
    return (
      <article
        className={`panel ${
          !this.props.taskModel.upListFastenNow &&
          !this.props.taskModel.upListFastenByCategoryNow
            ? 'panel-default'
            : 'panel-success'
        }`}
      >
        <div className="panel-heading text-center panel-inner-border-bottom">
          <div className="panel-title">
            <i className="fa fa-thumb-tack m-r-4" /> {t('Закрепить задание')}
          </div>
        </div>
        <div className="panel-body">
          <p className="">
            {t(
              'Закрепление задания поднимет её в топ списка, привлекая больше исполнителей.'
            )}
          </p>
          <p className="">
            {t(
              'Можно закрепить в текущей категории вашего задания и на главной странице, когда категория не выбранна (еще больше охват). <br class="hidden-xs" /> Последнее закрепленное задание попадает на 1 место, смещая остальные закрепленные ниже.'
            )}
          </p>

          <div className="row">
            <div className="col-xs-24 col-sm-8">
              <div className="form-group">
                <label className="control-label" htmlFor="category">
                  {t('Категория')}:
                </label>
                <div className="btn-group bootstrap-select form-control">
                  <button
                    type="button"
                    className="bs-placeholder btn btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    title={activeCategoriesSelect.label}
                    aria-expanded="false"
                  >
                    {activeCategoriesSelect.label}
                  </button>
                  <div
                    className="dropdown-menu open"
                    style={{ maxHeight: '264px', overflow: 'hidden' }}
                  >
                    <ul
                      className="dropdown-menu inner"
                      role="listbox"
                      aria-expanded="false"
                      style={{ maxHeight: '252px', overflowY: 'auto' }}
                    >
                      {this.state.categoriesSelect.items.map(item => (
                        <li
                          className={
                            this.state.categoriesSelect.value === item.value &&
                            'active'
                          }
                        >
                          <a
                            href=""
                            onClick={e => {
                              e.preventDefault();
                              this.setState({
                                ...this.state,
                                categoriesSelect: {
                                  ...this.state.categoriesSelect,
                                  ...{
                                    value: item.value
                                  }
                                }
                              });
                            }}
                          >
                            {item.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-24 col-sm-8">
              <div className="form-group">
                <label className="control-label" htmlFor="none">
                  {t('Количество дней')}:
                </label>
                <input
                  className="form-control ng-untouched ng-pristine ng-valid"
                  type="number"
                  min="1"
                  max="10"
                  value={this.state.days}
                  onChange={e => {
                    if (hasError('days')) {
                      const errors = this.state.errors.days;
                      delete errors.days;
                      this.setState({ days: e.target.value, errors });
                    } else {
                      this.setState({ days: e.target.value });
                    }
                  }}
                />
                {errorDesc('days')}
              </div>
            </div>
            <div className="col-xs-24 col-sm-8">
              <div className="form-group">
                <label className="control-label hidden-xs" htmlFor="none">
                  &nbsp;
                </label>
                <button
                  className="btn btn-block btn-primary"
                  onClick={this.sendForm}
                  disabled={this.state.days === ''}
                >
                  {getTotalCost()} <i className="fa fa-rub" />
                </button>
              </div>
            </div>
          </div>
          <div
            className={
              !this.props.taskModel.upListFastenNow &&
              !this.props.taskModel.upListFastenByCategoryNow &&
              'hidden'
            }
          >
            <p className="text-base title-line title-line_sm">
              {this.props.taskPlace > 0 ? (
                <span>
                  {t(`Ваше задание на {place} месте`, {
                    place: this.props.taskPlace
                  })}
                </span>
              ) : (
                <span>{t('Ваше задание не опубликовано')}</span>
              )}
            </p>
            <div className="row">
              <div className="col-xs-24 col-sm-12">
                <div className="form-group">
                  <button
                    className="btn btn-block btn-primary m-b-5"
                    type="button"
                    onClick={this.liftTask}
                  >
                    {t('Поднять на 1 место за {cost}', { cost: costLiftTask })}{' '}
                    <i className="fa fa-rub" />
                  </button>
                </div>
              </div>
              <div className="col-xs-24 col-sm-12">
                <div className="form-group">
                  <div
                    className="abc-checkbox abc-checkbox-primary checkbox m-t-10"
                    aria-expanded="false"
                  >
                    <input
                      className="styled"
                      id="checkbox1"
                      type="checkbox"
                      checked={this.state.showAutoLiftTaskBlock}
                      onChange={e => {
                        if (e.target.checked) {
                          // eslint-disable-next-line no-undef
                          $(`#pinAutoLiftForm`).collapse('show');
                        } else {
                          if (this.props.taskModel.autoLiftQueue) {
                            this.setAutoLiftInterval(null);
                          }
                          // eslint-disable-next-line no-undef
                          $(`#pinAutoLiftForm`).collapse('hide');
                        }
                        this.setState({
                          ...this.state,
                          showAutoLiftTaskBlock: !this.state
                            .showAutoLiftTaskBlock
                        });
                      }}
                    />
                    <label htmlFor="checkbox1">
                      <div className="text-strong m-b-4">
                        {t('Автоматическое поднятие по расписанию')}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="pinAutoLiftForm"
              className="collapse"
              role="tabpanel"
              aria-labelledby="headingSn1"
              aria-expanded="false"
              style={{ height: '0px' }}
            >
              <div className="row">
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="liftTaskIntervalInput"
                    >
                      Интервал:
                    </label>
                    <DefaultSelect
                      id={'liftTaskIntervalInput'}
                      selectTitleNullValue={null}
                      btnClassName={
                        'bs-placeholder btn btn-default dropdown-toggle'
                      }
                      selectArrItems={this.props.taskIntervalAutoLift}
                      value={this.state.autoUpTime}
                      handleChangeValue={value => {
                        this.setState({ autoUpTime: value });
                      }}
                    />
                  </div>
                </div>
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label className="control-label" htmlFor="none">
                      {t('Количество поднятий')}:
                    </label>
                    <input
                      className="form-control ng-untouched ng-pristine ng-valid"
                      type="number"
                      min="1"
                      max="1000"
                      value={this.state.queue}
                      onChange={e => {
                        if (hasError('auto_lift_queue')) {
                          const errors = this.state.errors.auto_lift_queue;
                          delete errors.auto_lift_queue;
                          this.setState({ queue: e.target.value, errors });
                        } else {
                          this.setState({ queue: e.target.value });
                        }
                      }}
                    />
                    {errorDesc('auto_lift_queue')}
                  </div>
                </div>
                <div className="col-xs-24 col-sm-8">
                  <div className="form-group">
                    <label className="control-label" htmlFor="none">
                      Бюджет: {this.state.queue * costLiftTask}{' '}
                      <i className="fa fa-rub" /> /{' '}
                      {formatter.formattedMinutes(
                        this.state.autoUpTime * this.state.queue
                      )}
                    </label>
                    <button
                      className="btn btn-block btn-primary"
                      onClick={() =>
                        this.setAutoLiftInterval(
                          this.state.autoUpTime,
                          this.state.queue
                        )
                      }
                      disabled={
                        this.state.autoUpTime ===
                          this.props.taskModel.autoLiftInterval &&
                        this.state.queue === this.props.taskModel.autoLiftQueue
                      }
                    >
                      {t('Применить')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="panel-footer">
          <div
            className={`row ${!this.props.taskModel.upListFastenNow &&
              !this.props.taskModel.upListFastenByCategoryNow &&
              'hidden'}`}
          >
            <div className="col-sm-16 col-xs-24">
              {this.props.taskModel.liftAt ? (
                <div className="text-muted form-control-static">
                  {t('Задание поднималось')}:{' '}
                  <strong>
                    {formatter.dateFormat1(this.props.taskModel.liftAt)}
                  </strong>
                </div>
              ) : (
                <div className="text-muted form-control-static">
                  {t('Задание не поднималось')}
                </div>
              )}
            </div>
            <div className="col-xs-24 col-sm-8">
              {this.props.taskModel.autoLiftInterval ? (
                <button
                  className="btn btn-block btn-danger"
                  type="button"
                  onClick={() => this.setAutoLiftInterval(null)}
                >
                  {t('Отключить автоподнятие')}
                </button>
              ) : (
                <button
                  className="btn btn-block btn-muted"
                  type="button"
                  disabled
                >
                  {t('Автоподнятие отключено')}
                </button>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-24">
              {this.props.taskModel.upListFastenNow && (
                <div className="form-control-static text-success">
                  {t('Задание закреплено')} ({this.state.mainLabel}) {t('до')}:{' '}
                  <strong>
                    {formatter.dateFormat5(
                      this.props.taskModel.upListFastenNow.andTime
                    )}
                  </strong>
                </div>
              )}
              {this.props.taskModel.upListFastenByCategoryNow && (
                <div className="form-control-static text-success">
                  {t('Задание закреплено')} ({this.state.categoryLabel}){' '}
                  {t('до')}:{' '}
                  <strong>
                    {formatter.dateFormat5(
                      this.props.taskModel.upListFastenByCategoryNow.andTime
                    )}
                  </strong>
                </div>
              )}
              {!this.props.taskModel.upListFastenNow &&
                !this.props.taskModel.upListFastenByCategoryNow && (
                  <div className="form-control-static text-muted">
                    {t('Задание не закреплено')}
                  </div>
                )}
            </div>
          </div>
        </div>
      </article>
    );
  }
}

TasksFastenForm.contextTypes = {};

TasksFastenForm.defaultProps = {
  taskPlace: 0
};

TasksFastenForm.propTypes = {
  // IN
  taskModel: PropTypes.shape({
    id: PropTypes.number,
    autoLiftInterval: PropTypes.string,
    autoLiftQueue: PropTypes.string,
    liftAt: PropTypes.string,
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    upListFastenByCategoryNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    taskTypeDesc: PropTypes.string.isRequired
  }).isRequired,
  updateTask: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  // Connect
  tasksUpListType: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    day_cost: PropTypes.string.isRequired,
    day_cost_by_category: PropTypes.string.isRequired
  }).isRequired,
  updateAccountInfo: PropTypes.func.isRequired,
  addClientNotice: PropTypes.func.isRequired,
  taskPlace: PropTypes.number,
  taskIntervalAutoLift: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  tasksUpListType: getItemFromRefList(state, 'tasksUpListTypes').find(
    i => i.id === 1
  ),
  taskIntervalAutoLift: getValueFromRefDataModules(
    state,
    'tasks.taskIntervalAutoLift'
  )
});

const mapDispatchToProps = dispatch => ({
  updateAccountInfo: () => dispatch(sendGetAuthAccountDataRequest()),
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksFastenForm);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksUpListPopUpNew/forms/TasksFastenForm.js